// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2YoLv","dragIcon":"Choice_dragIcon__1Qc35","left":"Choice_left__2ahxh","input":"Choice_input__3ZOY1"};